angular.module('app.controllers').controller('SpeakersCtrl', ['$scope', '$rootScope', 'Table', 'UI', 'APIRead', 'APIReadTable', '$interval', 'APIChats'].append(function(self, root, Table, UI, APIRead, APIReadTable, $interval, APIChats) {
  var cookiesName, getChatRooms, ref, roomsInterval, tableName;
  tableName = 's.experts.' + (((ref = root.user) != null ? ref.shortcode : void 0) || 'test');
  cookiesName = 't.' + tableName;
  self.experts = Table({
    name: tableName,
    type: "partial",
    resource: APIReadTable,
    params: {
      limit: 24,
      entry_type: 'experts,speakers',
      lang: root.lang
    }
  });
  self.$watch('experts.params', function(newObj, oldObj) {
    return self.page = 1;
  }, true);
  self.$watch('experts.data.display', function(newObj, oldObj) {
    return getChatRooms();
  }, true);
  self.page = 1;
  self.loadMore = function() {
    var params;
    if (self.page >= self.experts.data.pages) {
      return;
    }
    self.page++;
    params = angular.copy(self.experts.params);
    params.page = self.page;
    self.moreLoad = true;
    return APIRead.query(params, function(data) {
      self.more = data;
      self.experts.data.display = self.experts.data.display.concat(self.more);
      return self.moreLoad = false;
    });
  };
  self.openSpeakerModal = function(data = null, id = null) {
    return root.$broadcast('onSpeakerModalOpen', data, id);
  };
  //self.contactModalEl = document.getElementById('contactModal')
  //self.contactModal = bootstrap.Modal.getOrCreateInstance(self.contactModalEl) if self.contactModalEl
  getChatRooms = function() {
    var accounts, ref1;
    accounts = (ref1 = self.experts.data.display) != null ? ref1.map(function(expert) {
      return expert.chataccount;
    }).filter(function(expert) {
      return expert;
    }) : void 0;
    if (!accounts.length) {
      return;
    }
    return APIChats.query({
      _entry: 'meetings',
      accounts: accounts.join(","),
      include_offline: true
    }, function(data) {
      return data.forEach(function(item) {
        var ref2;
        return (ref2 = self.experts.data.display.find(function(expert) {
          return expert.chataccount === item.account.id;
        })) != null ? ref2.room = item : void 0;
      });
    });
  };
  return roomsInterval = $interval(getChatRooms, 30000);
}));

angular.module('app.controllers').controller('SpeakersModalCtrl', ['$scope', '$rootScope', 'APISpeakers', 'UI'].append(function(self, root, APISpeakers, UI) {
  var getSpeaker;
  self.id = null;
  self.data = null;
  self.speakerModalEl = document.getElementById('speakerModal');
  getSpeaker = function() {
    return APISpeakers.get({
      id: self.id
    }, function(data) {
      return self.data = data;
    }, function(response) {
      return UI.notify(false, response.data.error);
    });
  };
  if (self.speakerModalEl) {
    self.speakerModal = bootstrap.Modal.getOrCreateInstance(self.speakerModalEl);
    self.speakerModalEl.addEventListener('hidden.bs.modal', function(event) {
      self.id = null;
      self.data = null;
      return self.$applyAsync();
    });
    self.speakerModalEl.addEventListener('show.bs.modal', function(event) {
      if (!self.data) {
        getSpeaker();
      }
      return self.$applyAsync();
    });
  }
  return self.$on('onSpeakerModalOpen', function(event, data = null, id = null, modal = true) {
    self.id = id;
    self.data = data;
    if (modal) {
      return self.speakerModal.show();
    } else {
      return getSpeaker();
    }
  });
}));
